<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>

    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>

  <!-- ROW 1: title + filter -->
  <div class="top-bar profile-templates-header">
    <span class="page-header">
      {{ 'users:usergroups_templateprofile_header_name' | i18next : { defaultValue: 'Profile templates' } }}
    </span>

    <div class="profile-templates-actions-right">
      <input class="search-input" type="text"
        [placeholder]="'users:globalprofiles_filter_name_skills' | i18next : { defaultValue: 'Filter name or skills...' }"
        [(ngModel)]="filterText" (ngModelChange)="onFilterChange($event)" />
    </div>
  </div>

  <!-- ROW 2: action buttons -->
  <div class="profile-templates-actions-row">
    <div class="profile-templates-actions-left">
      <button class="btn-secondary" type="button" (click)="addProfile()" [disabled]="!model?.canEditMyCust">
        + {{ 'users:globalprofiles_addprofile_button' | i18next : { defaultValue: 'Add profile template' } }}
      </button>

      <button class="btn-secondary" type="button" (click)="copySelectedProfiles()"
        [disabled]="!canCopySelected || !model?.canEditMyCust">
        <i class="far fa-copy"></i>
        {{ 'users:usergroups_pasteProfile' | i18next : { defaultValue: 'Copy selected profiles' } }}
      </button>
    </div>

    <div class="profile-templates-actions-right">
      <button class="btn-ghost" type="button" (click)="undoChanges()" [disabled]="!hasChanges || !model?.canEditMyCust">
        {{ 'users:usergroups_undoUsergroupSettings' | i18next : { defaultValue: 'Undo changes' } }}
      </button>

      <button class="btn-primary" type="button" (click)="saveProfiles()"
        [disabled]="!hasChanges || !model?.canEditMyCust">
        {{ 'users:usergroups_saveUsergroupSettings' | i18next : { defaultValue: 'Save changes' } }}
      </button>
    </div>
  </div>

  <div class="margin-top-div-24"></div>

  <div class="content">

    <!-- Loading -->
    <div class="pause-loading" *ngIf="isLoading || isSaving">
      <span class="loading"></span>
    </div>

    <!-- Messages -->
    <div *ngIf="errorMessage" class="pause-message pause-message--error">
      {{ errorMessage }}
    </div>
    <div *ngIf="successMessage" class="pause-message pause-message--success">
      {{ successMessage }}
    </div>

    <div *ngIf="!isLoading">
      <table *ngIf="filteredProfiles && filteredProfiles.length" class="profiles-table">
        <thead>
          <tr>
            <th class="center col-number">#</th>
            <th class="left col-name">{{ 'users:profileNameHeader' | i18next }}</th>
            <th class="left col-skills"><span>{{ 'users:skillsHeader' | i18next }} </span>
              <div class="right"> {{ 'users:newuser_skillsHeader' | i18next }}</div>
            </th>
            <th class="center col-use" [matTooltip]="'users:tooltip_useProfile'| i18next"
              matTooltipClass="tooltip-font-14">{{ 'users:newuser_useProfileHeader' | i18next }}</th>
            <th class="center col-actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let profile of filteredProfiles; let i = index">
            <td class="center col-number">
              <div class="cell-frame">
                {{ profile.number || (i + 1) }}
              </div>
            </td>
            <!-- profile name -->
            <td class="left col-name">
              <div class="cell-frame">
                <app-basic-textbox [(model)]="profile.name" (modelChange)="onProfileNameChange(profile)"
                  [disabled]="!model?.canEditMyCust" size="small" width="176px" class="profile-name-textbox">
                </app-basic-textbox>
                <div *ngIf="profile.templateProfileId">{{'users:usergroups_baseonprofiletemplate' | i18next}}
                  {{profile.templateProfileName}}</div>
              </div>
            </td>
            <td class="left col-skills">
              <div class="cell-frame skills-cell">
                <app-skill-tag [profile]="profile" [canEditUsers]="model?.canEditMyCust" [isSortable]="false"
                  (addSkills)="openProfileSkills($event.profile)">
                </app-skill-tag>
              </div>
            </td>
            <td class="center col-use">
              <div class="cell-frame">
                <app-basic-checkbox [model]="profile.selected"
                  (modelChange)="toggleProfileSelected(profile, $event.target.checked)"
                  [disabled]="!model?.canEditMyCust">
                </app-basic-checkbox>
              </div>
            </td>
            <td class="center col-actions">
              <div class="cell-frame actions-cell">
                <button type="button" class="icon-button" [disabled]="!profile.hasChildProfile"
                  (click)="openChildProfiles(profile, $event)">
                  <i class="far fa-eye"></i>
                </button>
                <app-basic-button type="decline" isIcon="true" size="small" [disabled]="!model?.canEditMyCust"
                  (click)="deleteProfile(profile)" class="delete-button">
                  <i class="fal fa-times"></i>
                </app-basic-button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <table class="profiles-table modern-table" *ngIf="filteredProfiles && filteredProfiles.length">
        <thead>
          <tr>
            <th class="col-number">#</th>
            <th class="col-use">
              <input type="checkbox" disabled />
            </th>
            <th class="col-name">
              {{ 'users:shared_profileNameHeader' | i18next : { defaultValue: 'Profile name' } }}
            </th>
            <th class="col-skills" [innerHTML]="'users:shared_skillsHeader' | i18next : {
                defaultValue: 'Skills: (9 is highest, 1 is lowest, 0 is to pick from queue)'
                }">
            </th>
            <th class="col-eye">
              {{ 'users:globalprofiles_use_header' | i18next : { defaultValue: 'Use' } }}
            </th>
            <th class="col-delete">
              {{ 'users:shared_delete' | i18next : { defaultValue: 'Delete' } }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let profile of filteredProfiles; let i = index">
            <td class="col-number">{{ profile.number || (i + 1) }}</td>

            <td class="col-use-checkbox">
              <input type="checkbox" [checked]="profile.selected"
                (change)="toggleProfileSelected(profile, $event.target.checked)" [disabled]="!model?.canEditMyCust" />
            </td>


            <td class="col-name">
              <input type="text" class="profile-name-input" [(ngModel)]="profile.name"
                (ngModelChange)="onProfileNameChange(profile)" [disabled]="!model?.canEditMyCust" />
            </td>

            <td class="col-skills">
              <div class="skills-row">
                <ng-container *ngFor="let service of profile.skills">
                  <ng-container *ngFor="let q of service.qualities">
                    <div class="skill-chip">
                      <span class="skill-label">{{ q.name }}</span>
                      <select class="skill-level-select" [(ngModel)]="q.userLevel"
                        (ngModelChange)="onSkillLevelChange()" [disabled]="!model?.canEditMyCust">
                        <option *ngFor="let lvl of [0,1,2,3,4,5,6,7,8,9]" [ngValue]="lvl">
                          {{ lvl }}
                        </option>
                      </select>
                      <button type="button" class="chip-remove-btn" *ngIf="model?.canEditMyCust"
                        (click)="removeSkill(profile, service.serviceId, q.qualityId)">
                        ×
                      </button>
                    </div>
                  </ng-container>
                </ng-container>

                <button class="btn-chip-add" type="button" *ngIf="model?.canEditMyCust"
                  (click)="openAddSkillsDialog(profile, $event)">
                  +
                </button>
              </div>
            </td>

            <td class="col-eye">
              <button type="button" class="icon-button" [disabled]="!profile.hasChildProfile"
                (click)="openChildProfiles(profile, $event)">
                <i class="far fa-eye"></i>
              </button>
            </td>

            <td class="col-delete">
              <button type="button" class="icon-button icon-button-danger" (click)="deleteProfile(profile)"
                [disabled]="!model?.canEditMyCust">
                <i class="far fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table> -->

      <div *ngIf="filteredProfiles && !filteredProfiles.length && !isLoading">
        {{ 'users:globalprofiles_nodata' | i18next : { defaultValue: 'No profiles found.' } }}
      </div>
    </div>
  </div>

  <!-- CHILD PROFILES DIALOG -->
  <ng-template #childProfilesDialog let-data="data">
    <h2 class="dialog-title">
      {{ 'users:globalprofiles_childprofiledialog_header' | i18next : { defaultValue: 'Related profiles' } }}
    </h2>
    <p>
      {{ 'users:globalprofiles_childprofiledialog_comment' | i18next : { defaultValue: 'The following profiles will be
      affected:' } }}
    </p>
    <table class="child-profile-table">
      <tbody>
        <tr *ngFor="let cp of childProfiles">
          <td>
            <ul>
              <li>
                {{ 'users:usergroup' | i18next : { defaultValue: 'Usergroup' } }}:
                <span class="bold">{{ cp.usergroupName }}</span>
                {{ 'users:profile' | i18next : { defaultValue: 'Profile' } }}:
                <span class="bold">{{ cp.description }}</span>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-template>

  <!-- CHANGE WARNING DIALOG (affected profiles) -->
  <ng-template #changeWarningDialog>
    <h2 class="dialog-title">
      {{ 'users:globalprofiles_changewarning_header' | i18next : { defaultValue: 'Changes will affect these profiles' }
      }}
    </h2>
    <p>
      {{ 'users:globalprofiles_changewarning_comment' | i18next : { defaultValue: 'Saving will affect the following user
      profiles:' } }}
    </p>
    <table id="warningTable">
      <thead>
        <tr>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let profile of affectedProfiles">
          <td>
            <p>
              {{
              profile.action === 'u'
              ? ('users:changefrom' | i18next : { defaultValue: 'Changing profile' })
              : ('users:deleteprofile' | i18next : { defaultValue: 'Deleting profile' })
              }}
              <span class="bold">{{ profile.profileTemplateName }}</span>
              {{ 'users:changeaffect' | i18next : { defaultValue: 'will affect:' } }}
            </p>
            <ul>
              <li *ngFor="let change of profile.updatedProfiles">
                {{ 'users:usergroup' | i18next : { defaultValue: 'Usergroup' } }}:
                <span class="bold">{{ change.usergroupDescription }}</span>
                {{ 'users:profile' | i18next : { defaultValue: 'Profile' } }}:
                <span class="bold">{{ change.profileDescription }}</span>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="rightfloat dialog-actions">
      <button class="green" [mat-dialog-close]="'confirm'">
        {{ 'users:SaveChanges' | i18next : { defaultValue: 'Save changes' } }}
      </button>
      <button class="grey" mat-dialog-close>
        {{ 'users:Cancel' | i18next : { defaultValue: 'Cancel' } }}
      </button>
    </div>
  </ng-template>

  <!-- ACTIVE AGENTS WARNING DIALOG -->
  <ng-template #activeAgentsDialog>
    <h2 class="dialog-title">
      {{ 'users:usergroup_help_updatetmpprofilewarning_agentheader' | i18next : { defaultValue: 'Active agents warning'
      } }}
    </h2>
    <div id="UsersLoggedWarning">
      <span id="activeAgentCountSpan">{{ activeAgentsCount }}</span>
      {{ 'users:shared_UsersLoggedWarning' | i18next : { defaultValue: 'active agents are currently using these
      profiles.' } }}
    </div>
    <br />
    <div class="rightfloat dialog-actions">
      <button class="grey" [mat-dialog-close]="'confirm'">
        {{ 'users:shared_lang_yes' | i18next : { defaultValue: 'Yes' } }}
      </button>
      <button class="grey" mat-dialog-close>
        {{ 'users:shared_lang_no' | i18next : { defaultValue: 'No' } }}
      </button>
    </div>
  </ng-template>
</div>